import Vue from 'vue';
import Router from 'vue-router';
// import store from './../store'
// import { Message } from 'element-ui'
import api from './../api'

import routes from './routers';
Vue.use(Router);
// console.log(routes,'routes-------------')
const router = new Router({
  mode: 'history',
  routes,
});

let frontendConfig = null
router.beforeEach(async (to, from, next) => {
  console.log(to,'to=========================')
  const token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
  // 获取配置参数【主题，页面配置】
  if (!frontendConfig) {
    await api.configuration.getConfiguration().then(res => {
      if (res.code === 0 && res.data) {
        frontendConfig = res.data.frontendConfig.filter(item => {
          if (item.key === 'homepage') {
            return true;
          }
        })[0];
        localStorage.setItem('domain', JSON.stringify(res.data.domain)?JSON.stringify(res.data.domain):'');
        localStorage.setItem('theme', res.data.theme || '');
        localStorage.setItem('frontendConfig', frontendConfig ? JSON.stringify(frontendConfig) : '');
        localStorage.setItem('hasGetConfig', '1')
        localStorage.setItem('configurationArr', JSON.stringify(res.data.frontendConfig))
        localStorage.setItem('setTempConfigs', JSON.stringify(res.data))
        if(res.data.solutionInfo){
          localStorage.setItem('solutionInfo',JSON.stringify(res.data.solutionInfo))
        }
        if (res.data.pageLogo) {
          let link = document.querySelector("link[rel*='icon']");
          link.href = res.data.pageLogo;
          localStorage.setItem('pageLogo', res.data.pageLogo);
        }
        if (res.data.pageTitle) {
          document.title = res.data.pageTitle;
          localStorage.setItem('pageTitle', res.data.pageTitle)
        }
      }
    })
  }
  if(token && to.path === '/login'){//避免重复登录
    console.log(444444444444);

    next('/'+frontendConfig.value)
  }

  if (frontendConfig && frontendConfig.value && to.path === '/') {//配置的首页路由
    console.log(66666666666666666);

    next('/'+frontendConfig.value)
  }
  else if (to.path === '/courseGoods' || to.path === '/courseGoodsDetail') {
    next()
  }
  else if (to.meta && !to.meta.login) {//不需要登录
    console.log(55555555555555555555);

    next()
  } else {
    if (token) {
      // 军民登陆后需要判断是否完善资料
      // checkJunmin(next)
      next()
    } else {
      let pathname = window.location.pathname && window.location.pathname.replace('/','')
      let search = window.location.search
      let backPath = ''
      if(search){
        backPath = `${search}&name=${pathname}`
      }else{
        backPath = `?name=${pathname}`
      }
      console.log('pathname====================',window.location.pathname.replace('/',''));

      next(`/login${backPath}`)
    }
  }
})

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
